(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojoco-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mj-section').forEach(function (section) {
      var variantsEl = section.querySelector('[data-mj-variants]');
      if (!variantsEl) return;
      var variants = JSON.parse(variantsEl.textContent);

      var imagesEl = section.querySelector('[data-mj-images]');
      var images = imagesEl ? JSON.parse(imagesEl.textContent) : [];
      var imagesById = {};
      images.forEach(function (img) { imagesById[img.id] = img; });

      // PG/PW alt-text variant filtering: images alt-tagged "PG..." / "PW..." (case
      // insensitive) are grouped as Gray/White and matched against the selected
      // variant's color option. Takes priority over native variant-image assignment
      // below, and is a no-op (falls through) for products with no PG/PW tags.
      function getAltColorGroup(alt) {
        if (!alt) return null;
        var prefix = alt.trim().slice(0, 2).toUpperCase();
        if (prefix === 'PG') return 'gray';
        if (prefix === 'PW') return 'white';
        return null;
      }

      // 'gray'/'white' below are just internal bucket ids matched against PG/PW alt
      // prefixes - they don't need to stay in sync with the option's display language.
      // Recognizes both the original English values and the current Czech ones
      // (Šedá/Béžová) so this keeps working if the option text is translated again.
      function getVariantColorGroup(variant) {
        var opts = [variant.option1, variant.option2, variant.option3];
        for (var i = 0; i < opts.length; i++) {
          var value = (opts[i] || '').trim().toLowerCase();
          if (value.indexOf('gray') !== -1 || value.indexOf('grey') !== -1 || value.indexOf('šedá') !== -1 || value.indexOf('šedý') !== -1) {
            return 'gray';
          }
          if (value.indexOf('white') !== -1 || value.indexOf('béžová') !== -1 || value.indexOf('béžový') !== -1) {
            return 'white';
          }
        }
        return null;
      }

      var hasAltGroupImages = images.some(function (img) { return getAltColorGroup(img.alt) !== null; });

      // true only if the merchant has actually assigned specific photos to specific
      // variants in Admin (Product > Media > "assign to variant"); otherwise there's
      // nothing to filter by, so we fall back to showing the full gallery untouched.
      var hasVariantImages = images.some(function (img) { return img.variant_ids && img.variant_ids.length > 0; });

      var variantIdInput = section.querySelector('[data-mj-variant-id]');
      var quantityInput = section.querySelector('[data-mj-quantity]');
      var selectedValueEl = section.querySelector('[data-mj-selected-value]');
      var tierButtons = section.querySelectorAll('[data-mj-tier]');
      var mainImage = section.querySelector('[data-mj-main-image]');
      var thumbButtons = section.querySelectorAll('[data-mj-thumb]');
      var availabilityNote = section.querySelector('[data-mj-availability-note]');
      var form = variantIdInput ? variantIdInput.closest('form') : null;
      var selectedTierQty = 1;

      // Disables the buy buttons and shows an inline message when the resolved
      // variant is genuinely out of stock in Shopify (inventory = 0, "don't sell
      // when out of stock"). No amount of client-side fixing can add a checkout ID
      // that Shopify will accept for a variant it considers unavailable - this just
      // makes that state visible instead of letting the request fail silently.
      function updateAvailability(variant) {
        var isAvailable = !!(variant && variant.available);
        tierButtons.forEach(function (btn) {
          btn.disabled = !isAvailable;
        });
        if (availabilityNote) {
          availabilityNote.hidden = isAvailable;
          if (!isAvailable) {
            availabilityNote.textContent = 'Tato varianta je momentálně vyprodaná.';
          }
        }
        return isAvailable;
      }

      var selectedOptionValue = null;
      var activeSwatch = section.querySelector('.mj-swatch.is-active');
      if (activeSwatch) selectedOptionValue = activeSwatch.dataset.mjOptionValue;

      // Text-matching fallback only - used when a swatch has no data-mj-variant-id
      // (e.g. markup from an older cached page) or for the very first render before
      // any swatch has been clicked. Normalized (trimmed + lowercased) so casing or
      // stray whitespace in a translated option value can't cause a silent mismatch.
      function findVariantByText(optionValue) {
        if (!optionValue) return variants[0];
        var needle = optionValue.trim().toLowerCase();
        return variants.find(function (v) {
          return [v.option1, v.option2, v.option3].some(function (opt) {
            return opt && opt.trim().toLowerCase() === needle;
          });
        }) || variants[0];
      }

      // Single source of truth for "which variant is active right now". Every code
      // path (swatch click, tier click, URL preselect, initial render) reads and
      // writes this instead of re-deriving a variant from display text on its own -
      // that's what let a stale/mismatched text comparison silently fall back to
      // variants[0] and submit the wrong (sometimes sold-out) variant to the cart.
      var currentVariant = findVariantByText(selectedOptionValue);

      // Resolves a variant from a swatch button: prefers the server-computed
      // data-mj-variant-id (an exact Shopify variant ID, immune to translation/
      // casing/whitespace issues) and only falls back to text matching if that
      // attribute is missing for some reason.
      function resolveVariantFromSwatch(btn) {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (variantId) {
          var byId = variants.find(function (v) { return v.id === variantId; });
          if (byId) return byId;
        }
        return findVariantByText(btn.dataset.mjOptionValue);
      }

      // If the page was loaded with ?variant=<id> (e.g. a shared link), honor it and
      // pre-select the matching swatch instead of defaulting to the first option.
      (function applyVariantFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var urlVariantId = parseInt(params.get('variant'), 10);
        if (!urlVariantId) return;
        var urlVariant = variants.find(function (v) { return v.id === urlVariantId; });
        if (!urlVariant) return;
        var optionValue = urlVariant.option1 || urlVariant.option2 || urlVariant.option3;
        currentVariant = urlVariant;
        if (!optionValue) return;
        selectedOptionValue = optionValue;
        section.querySelectorAll('.mj-swatch').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.mjOptionValue === optionValue);
        });
        if (selectedValueEl) selectedValueEl.textContent = optionValue;
      })();

      function updateUrlForVariant(variant) {
        if (!variant || !window.history || !window.history.replaceState) return;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč';
      }

      function setActiveThumb(imageId) {
        thumbButtons.forEach(function (thumb) {
          thumb.classList.toggle('is-active', String(thumb.dataset.imageId) === String(imageId));
        });
      }

      // Navigates among only the currently-visible (non-hidden) thumbs, so prev/next
      // and swipe stay within whichever variant's photos are currently shown.
      function getVisibleThumbs() {
        return Array.prototype.filter.call(thumbButtons, function (thumb) { return !thumb.hidden; });
      }

      function stepGallery(delta) {
        var visible = getVisibleThumbs();
        if (visible.length < 2 || !mainImage) return;
        var activeIndex = visible.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
        if (activeIndex === -1) activeIndex = 0;
        var nextIndex = (activeIndex + delta + visible.length) % visible.length;
        var next = visible[nextIndex];
        mainImage.src = next.dataset.full;
        setActiveThumb(next.dataset.imageId);
      }

      function updateGalleryForVariant(variant) {
        if (!mainImage || !variant) return;

        if (hasAltGroupImages) {
          var variantGroup = getVariantColorGroup(variant);
          var altMatchedAny = false;

          thumbButtons.forEach(function (thumb) {
            var thumbImage = imagesById[thumb.dataset.imageId];
            var imgGroup = thumbImage ? getAltColorGroup(thumbImage.alt) : null;
            var mismatched = variantGroup && imgGroup && imgGroup !== variantGroup;
            thumb.hidden = mismatched;
            if (!mismatched) altMatchedAny = true;
          });

          if (!altMatchedAny) {
            thumbButtons.forEach(function (thumb) { thumb.hidden = false; });
          }

          if (variant.featured_image && variant.featured_image.id) {
            mainImage.src = variant.featured_image.src.split('?')[0] + '?width=1600';
            setActiveThumb(variant.featured_image.id);
          } else {
            var firstVisibleAltMatch = Array.prototype.find.call(thumbButtons, function (thumb) { return !thumb.hidden; });
            if (firstVisibleAltMatch) {
              mainImage.src = firstVisibleAltMatch.dataset.full;
              setActiveThumb(firstVisibleAltMatch.dataset.imageId);
            }
          }
          return;
        }

        if (!hasVariantImages) {
          // No per-variant image assignments exist on this product — nothing to filter,
          // leave the gallery exactly as-is (avoids hiding photos with no mapping).
          return;
        }

        var variantImageIds = images
          .filter(function (img) { return img.variant_ids && img.variant_ids.indexOf(variant.id) !== -1; })
          .map(function (img) { return img.id; });

        var matchedAny = false;

        thumbButtons.forEach(function (thumb) {
          var thumbImageId = parseInt(thumb.dataset.imageId, 10);
          var belongsToVariant = variantImageIds.indexOf(thumbImageId) !== -1;
          thumb.hidden = variantImageIds.length > 0 && !belongsToVariant;
          if (belongsToVariant) matchedAny = true;
        });

        // Fallback per spec: if the mapping isn't fully bound (no images matched this
        // variant), show every thumb again rather than leaving an empty gallery.
        if (!matchedAny) {
          thumbButtons.forEach(function (thumb) { thumb.hidden = false; });
        }

        // Prefer the variant's own featured_image (Shopify's authoritative choice),
        // else the first matching thumb, else leave the main image untouched.
        if (variant.featured_image && variant.featured_image.id) {
          mainImage.src = variant.featured_image.src.split('?')[0] + '?width=1600';
          setActiveThumb(variant.featured_image.id);
        } else if (matchedAny) {
          var firstMatch = Array.prototype.find.call(thumbButtons, function (thumb) { return !thumb.hidden; });
          if (firstMatch) {
            mainImage.src = firstMatch.dataset.full;
            setActiveThumb(firstMatch.dataset.imageId);
          }
        }
      }

      function renderTiers() {
        var variant = currentVariant;
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        updateAvailability(variant);

        tierButtons.forEach(function (btn) {
          var qty = parseInt(btn.dataset.qty, 10);
          var pct = parseInt(btn.dataset.pct, 10);
          var originalTotal = variant.price * qty;
          var discountedTotal = Math.round(originalTotal * (1 - pct / 100));

          var compareEl = btn.querySelector('[data-mj-tier-compare]');
          var totalEl = btn.querySelector('[data-mj-tier-total]');

          if (pct > 0) {
            if (compareEl) compareEl.textContent = formatMoney(originalTotal);
            if (totalEl) totalEl.textContent = formatMoney(discountedTotal);
          } else {
            if (totalEl) totalEl.textContent = formatMoney(originalTotal);
          }

          btn.classList.toggle('is-selected', qty === selectedTierQty);
        });
      }

      section.querySelectorAll('.mj-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.querySelectorAll('.mj-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selectedOptionValue = btn.dataset.mjOptionValue;
          if (selectedValueEl) selectedValueEl.textContent = selectedOptionValue;

          currentVariant = resolveVariantFromSwatch(btn);

          updateGalleryForVariant(currentVariant);
          updateUrlForVariant(currentVariant);
          renderTiers();
        });
      });

      thumbButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hidden) return;
          thumbButtons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (mainImage) mainImage.src = btn.dataset.full;
        });
      });

      tierButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedTierQty = parseInt(btn.dataset.qty, 10);
          if (quantityInput) quantityInput.value = selectedTierQty;
          renderTiers();
        });
      });

      // Final guard on the form itself: logs exactly what's about to be submitted
      // and blocks the request (with a clear message) if the variant ID in the
      // hidden input doesn't match the resolved currentVariant, or if that variant
      // is unavailable - instead of letting an invalid request reach /cart/add and
      // surface Shopify's generic "Something went wrong" error.
      if (form) {
        form.addEventListener('submit', function (event) {
          var submittedId = variantIdInput ? parseInt(variantIdInput.value, 10) : NaN;

          console.log('[MOJOCO bundle] submitting variant', {
            submittedVariantId: submittedId,
            currentVariant: currentVariant,
            quantity: quantityInput ? quantityInput.value : null
          });

          var idMismatch = !submittedId || !currentVariant || currentVariant.id !== submittedId;
          var isSoldOut = !updateAvailability(currentVariant);

          if (idMismatch || isSoldOut) {
            event.preventDefault();
            if (availabilityNote) {
              availabilityNote.hidden = false;
              availabilityNote.textContent = isSoldOut
                ? 'Tato varianta je momentálně vyprodaná.'
                : 'Nepodařilo se určit vybranou variantu, zkuste to prosím znovu.';
            }
            console.warn('[MOJOCO bundle] blocked submit', {
              reason: isSoldOut ? 'unavailable' : 'id-mismatch',
              submittedVariantId: submittedId,
              currentVariant: currentVariant
            });
            return;
          }

          // Meta Pixel: fire AddToCart for the bundle actually being submitted,
          // right before the browser hands the form off to /cart/add.
          var currentVariantId = currentVariant.id;
          var activeTierBtn = Array.prototype.find.call(tierButtons, function (b) {
            return parseInt(b.dataset.qty, 10) === selectedTierQty;
          });
          var tierPct = activeTierBtn ? parseInt(activeTierBtn.dataset.pct, 10) : 0;
          var tierQty = quantityInput ? parseInt(quantityInput.value, 10) : selectedTierQty;
          var originalTotal = currentVariant.price * tierQty;
          var discountedTotal = Math.round(originalTotal * (1 - tierPct / 100));
          var currentBundlePrice = discountedTotal / 100;

          if (typeof fbq === 'function') {
            fbq('track', 'AddToCart', {
              content_ids: [currentVariantId],
              content_type: 'product',
              value: currentBundlePrice,
              currency: 'CZK'
            });
            fbq('track', 'InitiateCheckout', {
              content_ids: [currentVariantId],
              content_type: 'product',
              value: currentBundlePrice,
              currency: 'CZK'
            });
          }
        });
      }

      // Prev/next arrow buttons
      var prevBtn = section.querySelector('[data-mj-gallery-prev]');
      var nextBtn = section.querySelector('[data-mj-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { stepGallery(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stepGallery(1); });

      // Touch swipe support on the main gallery image
      var galleryMain = section.querySelector('[data-mj-gallery-main]');
      if (galleryMain) {
        var touchStartX = 0;
        var touchStartY = 0;
        var isHorizontalSwipe = false;

        galleryMain.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isHorizontalSwipe = false;
        }, { passive: true });

        galleryMain.addEventListener('touchmove', function (e) {
          var dx = e.touches[0].clientX - touchStartX;
          var dy = e.touches[0].clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy)) {
            isHorizontalSwipe = true;
            // Only block vertical page scroll once we're sure this is a horizontal swipe.
            e.preventDefault();
          }
        }, { passive: false });

        galleryMain.addEventListener('touchend', function (e) {
          if (!isHorizontalSwipe) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var SWIPE_THRESHOLD = 40;
          if (Math.abs(dx) < SWIPE_THRESHOLD) return;
          stepGallery(dx < 0 ? 1 : -1);
        });
      }

      updateGalleryForVariant(currentVariant);
      renderTiers();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
